module.exports = __webpack_public_path__ + "static/img/9.7ae08d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/9.png
// module id = OhAl
// module chunks = 0